import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FileCard } from 'components/misc'
import { ElevatedButton, DashboardGrid as Grid } from 'components/layout'
import { FileUploadModal, FileDeleteModal } from 'components/modals'
import { FileLoader } from 'components/loaders'
import { apiDashboard } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'

@apiDashboard.apiAwards({ loadFiles: true })
@modal.trigger()
@connect(state => ({
  imageUploading: state.api.blob.loading
}))
class AwardFiles extends Component {
  static propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    sectionId: PropTypes.string,
    category: PropTypes.string.isRequired,
    modalObj: PropTypes.object,
    awardFiles: PropTypes.object,
    onUploadAwardFile: PropTypes.func,
    onDeleteAwardFile: PropTypes.func,
    imageUploading: PropTypes.bool,
    awards: PropTypes.object,
    readOnly: PropTypes.bool
  }

  render() {
    const {
      awards,
      sectionId,
      awardFiles,
      category,
      imageUploading,
      modalObj,
      readOnly
    } = this.props

    return (
      <Grid.RightInner>
        <div className="base-margin--bottom">
          <ElevatedButton
            onClick={() => this.props.onOpen(MODALS.FILE_UPLOAD)}
            intlKey="button.upload_file"
            rounded
            uppercase
            disabled={readOnly}
          >
            Upload file
          </ElevatedButton>
        </div>
        <p className="note">
          <FormattedMessage
            id="label.you_can_upload_here_any_files"
            defaultMessage="You can upload here any files you want to share with your Award Leader."
          />
        </p>
        {!awardFiles.loading ? (
          <div className="row">
            {awardFiles.data &&
              awardFiles.data
                .filter(item => get(item, 'section.value') === sectionId)
                .map(item => (
                  <div key={item.id} className="col-xs-12 col-sm-6">
                    <FileCard
                      src={item.fileUrl}
                      file={item}
                      awardId={get(awards, 'data.id')}
                      onDeleteClick={(awardId, awardFileId) =>
                        this.props.onOpen(MODALS.FILE_DELETE, null, {
                          awardId,
                          awardFileId
                        })
                      }
                    />
                  </div>
                ))
                .reverse()}
          </div>
        ) : (
          <FileLoader />
        )}

        <FileUploadModal
          modalId={MODALS.FILE_UPLOAD}
          awardId={get(awards, 'data.id')}
          sectionId={sectionId}
          category={category}
          onSubmit={this.props.onUploadAwardFile}
          loading={imageUploading}
        />
        <FileDeleteModal
          modalId={MODALS.FILE_DELETE}
          onClose={this.props.onClose}
          onConfirm={() => this.props.onDeleteAwardFile(modalObj.data)}
        />
      </Grid.RightInner>
    )
  }
}

export default AwardFiles
